import { colors } from 'ui/theme/colors';
import { getColor } from 'ui/icons/utils';
import { SvgIcon, SvgIconProps } from 'ui/icons/SvgIcon';

export const KeyTab = ({
  height = 16,
  width = 28,
  color = colors.iconPrimary,
  isColorInherited = false,
  ...props
}: SvgIconProps) => (
  <SvgIcon data-temporary-fix height={height} width={width} viewBox="0 0 28 16" {...props}>
    <path
      d="M2.77151 16C1.85983 16 1.16999 15.772 0.701994 15.3159C0.233998 14.8597 0 14.1756 0 13.2634V2.74572C0 1.83352 0.233998 1.14937 0.701994 0.693273C1.16999 0.231091 1.85983 0 2.77151 0H25.2285C26.1462 0 26.8361 0.231091 27.298 0.693273C27.766 1.15545 28 1.8396 28 2.74572V13.2634C28 14.1695 27.766 14.8506 27.298 15.3067C26.8361 15.7689 26.1462 16 25.2285 16H2.77151ZM2.83533 14.4584H25.1647C25.5719 14.4584 25.8879 14.3489 26.1128 14.13C26.3377 13.9111 26.4501 13.5857 26.4501 13.1539V2.85519C26.4501 2.42341 26.3377 2.09806 26.1128 1.87913C25.8879 1.66021 25.5719 1.55074 25.1647 1.55074H2.83533C2.42203 1.55074 2.10598 1.66021 1.88718 1.87913C1.66838 2.09806 1.55897 2.42341 1.55897 2.85519V13.1539C1.55897 13.5857 1.66838 13.9111 1.88718 14.13C2.10598 14.3489 2.42203 14.4584 2.83533 14.4584Z"
      fill={getColor(color, isColorInherited)}
    />
    <path
      d="M10.192 3.98605V5.29405H7.828V12.2541H6.364V5.29405H4V3.98605H10.192Z"
      fill={getColor(color, isColorInherited)}
    />
    <path
      d="M14.597 6.65005H15.989V12.2541H14.597V11.3781C14.225 11.9901 13.481 12.3981 12.677 12.3981C11.177 12.3981 9.977 11.1861 9.977 9.44605C9.977 7.75405 11.129 6.50605 12.713 6.50605C13.481 6.50605 14.225 6.84205 14.597 7.43005V6.65005ZM12.965 11.1021C13.829 11.1021 14.573 10.3821 14.573 9.44605C14.573 8.48605 13.781 7.80205 12.953 7.80205C12.053 7.80205 11.369 8.54605 11.369 9.44605C11.369 10.3461 12.053 11.1021 12.965 11.1021Z"
      fill={getColor(color, isColorInherited)}
    />
    <path
      d="M21.0129 6.50605C22.4889 6.50605 23.7609 7.64605 23.7609 9.44605C23.7609 11.2341 22.4769 12.3981 21.0009 12.3981C20.3289 12.3981 19.5249 12.0981 19.1409 11.4981V12.2541H17.7489V3.60205H19.1409V7.39405C19.5249 6.79405 20.3049 6.50605 21.0129 6.50605ZM20.7849 11.1021C21.6489 11.1021 22.3689 10.3701 22.3689 9.43405C22.3689 8.49805 21.6489 7.80205 20.7849 7.80205C19.9809 7.80205 19.1649 8.45005 19.1649 9.43405C19.1649 10.4181 19.9329 11.1021 20.7849 11.1021Z"
      fill={getColor(color, isColorInherited)}
    />
  </SvgIcon>
);
